/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import useBrand from '../../../hooks/use-brand';
import styles from './KeyLine.less';

var KeyLine = function KeyLine(_ref) {
  var className = _ref.className;
  var brand = useBrand();
  var classNames = getClasses({
    styles: styles,
    classes: ['keyLine', className],
    brand: brand
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  });
};

export default KeyLine;